import React from "react";
import { motion } from "framer-motion";
import { Wrench, Sofa, ShoppingBag, ArrowUpRight } from "lucide-react";
import { useI18n } from "../i18n";

const Marketing = () => {
  const { t } = useI18n();
  const m = (t.marketing) || {};

  const items = [
    {
      Icon: Wrench,
      title: m.hardware?.title || "Hırdavat",
      desc: m.hardware?.desc || "Çelik konstrüksiyon vidaları, yapısal bağlantı elemanları, endüstriyel sabitleme ürünleri ve profesyonel el aletleri. Şantiye ve fabrikalar için uçtan uca tedarik.",
      tags: m.hardware?.tags || ["Çelik bağlantı", "Endüstriyel aletler", "Şantiye sarf"],
      img: "https://images.unsplash.com/photo-1530124566582-a618bc2615dc?w=1200&q=80",
    },
    {
      Icon: Sofa,
      title: m.deco?.title || "Dekorasyon",
      desc: m.deco?.desc || "Endüstriyel aydınlatma, çelik mobilya, mimari panel sistemleri ve ofis dekorasyonu. Yapıların kabuğunu içerideki estetikle tamamlıyoruz.",
      tags: m.deco?.tags || ["Çelik mobilya", "Mimari panel", "Ofis tasarım"],
      img: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=1200&q=80",
    },
    {
      Icon: ShoppingBag,
      title: m.market?.title || "Market",
      desc: m.market?.desc || "Endüstriyel sarf malzeme, kişisel güvenlik ekipmanı (KKE), iş kıyafeti ve şantiye günlük tüketim ürünleri. Tek tedarikçiden uçtan uca lojistik.",
      tags: m.market?.tags || ["KKE & iş güvenliği", "Endüstriyel sarf", "Şantiye tedarik"],
      img: "https://images.unsplash.com/photo-1601598851547-4302969d0614?w=1200&q=80",
    },
  ];

  return (
    <section id="marketing" className="relative py-24 md:py-32 bg-[var(--bg)] overflow-hidden" data-testid="marketing-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.8 }}
          className="mb-12 md:mb-16 max-w-3xl"
        >
          <div className="overline mb-4">{m.overline || "MARKETING"}</div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-light text-white leading-[1.05] mb-4">
            {m.title || "Ürün ve Marka Vitrinimiz"}
          </h2>
          <p className="text-base text-[var(--text-muted)] leading-relaxed">
            {m.subtitle || "İnşaat sektörünün ötesinde, yapı malzemesinden endüstriyel tedariğe üç güçlü kategori."}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[var(--border)]">
          {items.map(({ Icon, title, desc, tags, img }, i) => (
            <motion.div
              key={title}
              initial={{ opacity: 0, y: 32 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-80px" }}
              transition={{ duration: 0.7, delay: i * 0.08 }}
              className="group relative bg-[var(--surface)] overflow-hidden cursor-pointer"
              data-testid={`marketing-card-${i}`}
            >
              <div className="aspect-[4/3] overflow-hidden bg-black">
                <img src={img} alt={title} loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110 opacity-80 group-hover:opacity-100" />
              </div>
              <div className="p-8 md:p-10">
                <div className="flex items-start justify-between mb-6">
                  <Icon size={32} strokeWidth={1} className="text-[var(--silver)]" />
                  <ArrowUpRight size={18} className="text-white/40 group-hover:text-white transition-colors" />
                </div>
                <h3 className="font-display text-2xl font-medium text-white mb-3">{title}</h3>
                <p className="text-sm leading-relaxed text-[var(--text-muted)] mb-5">{desc}</p>
                <div className="flex flex-wrap gap-2">
                  {tags.map((tag) => (
                    <span key={tag} className="text-[10px] tracking-widest uppercase border border-[var(--border)] px-2 py-1 text-[var(--text-muted)]">
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Marketing;
